import React from 'react'
import './about-section.scss'
import { StaticImage } from 'gatsby-plugin-image'
import { navigate } from 'gatsby'
import Button from '../../atoms/button/button'
import useMediaQuery from '../../../utils/useMediaQuery'
import { LOCALE_AT } from '../../../constants/activity-constants'
import { WORDS } from '../../../constants/keywords'

export default function AboutSection({ id }) {
  const isMobile = useMediaQuery()

  function ImageAmigas({ isMobile }) {
    const imgProps = {
      alt: 'Amigas',
      height: 522,
      placeholder: 'blurred',
      className: '',
    }
    if (isMobile) {
      imgProps.height = 405
    }

    return (
      <StaticImage
        src="../../../assets/images/about/imagen-amigas.png"
        {...imgProps}
      />
    )
  }

  const handleBtnPlay = () => {
    navigate('/play')
  }

  function ImageInsignias({ isMobile }) {
    return (
      <>
        <Insignias isMobile={isMobile} />
        <div className="f-about-section__aside__text">
          <p className="--bold">
            <PhraseByLocale />
          </p>
          <p>{WORDS.Gira} la ruleta, responde las preguntas, y {WORDS.gana} insignias.</p>
          <p className="--bold">
            ¡Que comience el juego y que ganen las mejores!
          </p>
          <Button onClick={handleBtnPlay} tag="7A">
            ¡QUIERO JUGAR YA!
          </Button>
        </div>
      </>
    )
  }

  return (
    <section id={id} className="f-about-section">
      <div className="f-about-section__wrapper">
        <aside className="f-about-section__aside flex --column">
          <ImageAmigas isMobile={isMobile} />
        </aside>
        <aside className="f-about-section__aside flex --column --media">
          <ImageInsignias isMobile={isMobile} />
        </aside>
      </div>
    </section>
  )
}
function PhraseByLocale() {
  if (LOCALE_AT.ARGENTINA || LOCALE_AT.PARAGUAY) {
    return (
      <>
        Preparate para demostrar tu conocimiento y habilidades. En este nuevo
        reto, solo las verdaderas expertas Nosotras® serán recompensadas y
        podrán ganar muchos premios.
      </>
    )
  }
  return (
    <>
      Prepárate para demostrar tu conocimiento y habilidades. En este nuevo
      reto, solo las verdaderas expertas Nosotras® serán recompensadas y podrán
      ganar muchos premios.
    </>
  )
}
function Insignias({ isMobile }) {
  let imgProps = {
    alt: 'Insignias',
    height: 250,
    placeholder: 'blurred',
    className: '',
  }
  if (isMobile) {
    imgProps.height = 200
  }

  if (LOCALE_AT.CHILE) {
    return (
      <StaticImage
        src="../../../assets/images/about/insignias-cl.png"
        {...imgProps}
      />
    )
  }
  if (LOCALE_AT.PARAGUAY) {
    return (
      <StaticImage
        src="../../../assets/images/about/insignias-py.png"
        {...imgProps}
      />
    )
  }

  if (LOCALE_AT.PERU) {
    return (
      <StaticImage
        src="../../../assets/images/about/insignias-pe.png"
        {...imgProps}
      />
    )
  }
  return (
    <StaticImage
      src="../../../assets/images/about/imagen-insignias.png"
      {...imgProps}
    />
  )
}
